import { gql } from '@apollo/client'

import { getQueryService } from '../../../../helpers/GraphqlHelpers'
import { ValidateSirenOrRnaQuery } from '../../../generated/graphql'

export const validateSirenOrRna = getQueryService({
  query: gql`
    query validateSirenOrRna($sirenOrRna: String!) {
      validateSirenOrRna(sirenOrRna: $sirenOrRna) {
        city
        address
        postalCode
        companyName
      }
    }
  `,
  transformer: (response: ValidateSirenOrRnaQuery) => {
    return response.validateSirenOrRna
  },
})
